import { render, staticRenderFns } from "./SerialType.vue?vue&type=template&id=179556fe"
import script from "./SerialType.vue?vue&type=script&lang=js"
export * from "./SerialType.vue?vue&type=script&lang=js"
import style0 from "./SerialType.vue?vue&type=style&index=0&id=179556fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports